<app-header></app-header>

<!-- global alert -->
<alert></alert>

<router-outlet></router-outlet>
<app-footer></app-footer>